import { styled, IconButton, Box, Stack } from '@mui/material';

export const StyleTabPanel = {
  Container: styled(Stack, {
    shouldForwardProp: prop => prop !== 'background',
  })<{
    background: string;
  }>(({ background }) => ({
    padding: '8px 0',
    height: 'calc(100% - 36px)',
    backgroundColor: background,
    borderRadius: '8px',
  })),
  DownloadAllButton: styled(IconButton)(({ theme }) => ({
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '26px',
    color: theme.palette.secondary.darker,
    backgroundColor: theme.palette.secondary.light,
    padding: '8px',
    borderRadius: '8px',
    ':hover': {
      backgroundColor: '#9DA9DB',
    },
    fontFamily: theme.typography.fontFamily,
  })),
  DownloadButton: styled(IconButton)(({ theme }) => ({
    width: '32px',
    height: '32px',
    color: theme.palette.secondary.darker,
    backgroundColor: theme.palette.secondary.light,
    padding: '6px',
    borderRadius: '8px',
    ':hover': {
      backgroundColor: '#9DA9DB',
    },
  })),
  Tag: styled(Box)(({ theme }) => ({
    padding: '1px 8px',
    marginRight: '4px',
    color: theme.palette.common.white,
    backgroundColor: '#F27934',
    borderRadius: '6px',
  })),
  StateBox: styled(Box)(() => ({
    height: '100%',
    '> div': {
      height: '100%',
    },
    '& img': {
      height: '90%',
    },
  })),
};
